//@flow
import React from 'react';
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {useTranslation} from "react-i18next";
import {EXHIBITION} from "../../locales/components/namespaces";
import {copyToClipboard} from "../../helpers/copyToClipboard";

type Props = {
    text: string,
}

const CopyToClipboard = (props: Props) => {
    const {t} = useTranslation(EXHIBITION)
    const [open, setOpen] = React.useState(false)
    const [title, setTitle] = React.useState('')
    const handleClose = () => {
        setTimeout(() => {
            setOpen(false)
        }, 1000)
    }
    const handleOpen = () => {
        setTitle(t('Copy'))
        setOpen(true)
    }
    const {text} = props
    return (
        <ListItem sx={{bgcolor: 'primary.main', color: 'primary.main.contrastText'}}>
            <ListItemText
                primary={text}
            />
            <Tooltip
                open={open}
                onOpen={handleOpen}
                onClose={handleClose}
                title={title}
            >
                <IconButton
                    color={"inherit"}
                    onClick={(e) => {
                        setTitle(t('Copied'))
                        copyToClipboard(text)
                        e.stopPropagation()
                    }}>
                    <ContentCopyIcon/>
                </IconButton>
            </Tooltip>
        </ListItem>
    )
}

export default CopyToClipboard;